import './OmniSearch.module.scss'
import { AccountResultFragment } from 'graphql/bindings/AdminBindings'
import { Avatar, Box, Grid, useRouter, useTheme } from '@forgeglobal/design-framework'
import { OmniSearch as BaseOmniSearch } from 'isolated-design-library'
import { InputActionMeta } from 'react-select/lib/types'
import { Routes } from 'util/Routes'
import { resolveOmnisearch } from 'util/TypeaheadTools'
import React, { useState } from 'react'

const formatOptionLabel = (data: AccountResultFragment | 'empty') => {
  if (data === 'empty') {
    return <div />
  }
  const emailContactMethod =
    data.type === 'individual'
      ? data.contact_methods.find(method => method.is_primary && method.channel === 'email')
      : null
  const individualEmail = emailContactMethod ? emailContactMethod.channel_value : ''

  const getSecondElementData = () => {
    if (data.issuer_account) {
      return data.issuer_account.company.legal_name || data.issuer_account!.company.name
    }
    const parentAccountNames = data.parents
      .map(rel => rel.parent_account.name)
      .map(name => <div key={name}>{name}</div>)
    return data.type === 'individual' ? parentAccountNames : data.client_type
  }
  const getThirdElementData = () => {
    if (data.issuer_account) {
      return data.issuer_account.company.domain
    }
    return data.type === 'individual' ? individualEmail : ''
  }
  return (
    <Grid container className="omnisearch-option">
      <Grid item xs={4} className="subtext">
        <Box display="flex" alignItems="center" height="100%">
          {data.issuer_account ? (
            <Avatar src={`${data.issuer_account.company.logo_url}?size=50`} style={{ height: 50, width: 50 }} />
          ) : null}
          <Box className="title" pl={data.issuer_account ? 2 : 0}>
            {data.name}
          </Box>
        </Box>
      </Grid>
      <Grid item xs={4} className="subtext">
        <Box display="flex" alignItems="center" height="100%">
          {getSecondElementData()}
        </Box>
      </Grid>
      <Grid item xs={4} className="subtext">
        <Box display="flex" alignItems="center" height="100%">
          {getThirdElementData()}
        </Box>
      </Grid>
    </Grid>
  )
}

const formatGroupLabel = (group: any) => (
  <div className="omnisearch-group-label">
    {group.label !== 'Accounts: Organizations' && <hr className="section-break" />}
    <div>{group.label}</div>
    {(group.options.length === 0 || group.options[0] === 'empty') && <div className="no-results">No results</div>}
  </div>
)

export const OmniSearch: React.FC = () => {
  const theme = useTheme()
  const { history } = useRouter()
  const [inputValue, setInputValue] = useState('')
  const onInputChange = (newInputValue: string, action: InputActionMeta) => {
    if (action.action !== 'input-blur' && action.action !== 'menu-close') {
      setInputValue(newInputValue)
    }
  }

  const onSelect = (data: AccountResultFragment | 'empty') => {
    if (data !== 'empty') {
      if (data.type === 'issuer') {
        history.push(Routes.issuer(data.id))
      } else {
        history.push(Routes.account(data.id))
      }
      setInputValue('')
    }
  }

  return (
    <BaseOmniSearch
      style={{ margin: theme.spacing(2, 0) }}
      onChange={e => e && onSelect(e as any)}
      onInputChange={onInputChange}
      inputValue={inputValue}
      value={null}
      formatOptionLabel={formatOptionLabel}
      formatGroupLabel={formatGroupLabel}
      loadOptions={resolveOmnisearch}
    />
  )
}
